// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ActiveStorageAttachment from "./active-storage-attachment.js"
import AgendaItem from "./agenda-item.js"
import AgendaItemElementSpeaker from "./agenda-item-element-speaker.js"
import Election from "./election.js"
import ElectionPost from "./election-post.js"

const modelClassData = {
  "attributes": {
    "agenda_item_id": {
      "column": {
        "default": null,
        "name": "agenda_item_id",
        "null": false,
        "type": "uuid"
      },
      "name": "agenda_item_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_id": {
      "column": {
        "default": null,
        "name": "election_id",
        "null": true,
        "type": "uuid"
      },
      "name": "election_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_post_id": {
      "column": {
        "default": null,
        "name": "election_post_id",
        "null": true,
        "type": "uuid"
      },
      "name": "election_post_id",
      "selected_by_default": null,
      "translated": null
    },
    "element_type": {
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      },
      "name": "element_type",
      "selected_by_default": null,
      "translated": null
    },
    "file_path": {
      "column": null,
      "name": "file_path",
      "selected_by_default": null,
      "translated": null
    },
    "headline": {
      "column": {
        "default": null,
        "name": "headline",
        "null": true,
        "type": "text"
      },
      "name": "headline",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "locked": {
      "column": {
        "default": false,
        "name": "locked",
        "null": false,
        "type": "boolean"
      },
      "name": "locked",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "proposal_id": {
      "column": {
        "default": null,
        "name": "proposal_id",
        "null": true,
        "type": "uuid"
      },
      "name": "proposal_id",
      "selected_by_default": null,
      "translated": null
    },
    "proposal_type_id": {
      "column": {
        "default": null,
        "name": "proposal_type_id",
        "null": true,
        "type": "uuid"
      },
      "name": "proposal_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "streaming_enabled": {
      "column": {
        "default": true,
        "name": "streaming_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "streaming_enabled",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "video_autoplay": {
      "column": {
        "default": false,
        "name": "video_autoplay",
        "null": false,
        "type": "boolean"
      },
      "name": "video_autoplay",
      "selected_by_default": null,
      "translated": null
    },
    "video_url": {
      "column": {
        "default": null,
        "name": "video_url",
        "null": true,
        "type": "string"
      },
      "name": "video_url",
      "selected_by_default": null,
      "translated": null
    },
    "activity_id": {
      "column": null,
      "name": "activity_id",
      "selected_by_default": false,
      "translated": null
    },
    "translated_element_type": {
      "column": null,
      "name": "translated_element_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "AgendaItemElement",
  "collectionKey": "agenda_item_elements",
  "collectionName": "agenda_item_elements",
  "i18nKey": "agenda_item_element",
  "camelizedLower": "agendaItemElement",
  "name": "AgendaItemElement",
  "nameDasherized": "agenda-item-element",
  "pluralName": "agenda_item_elements",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "agenda_item"
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item",
      "macro": "belongs_to",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "AgendaItemElementSpeaker",
      "collectionName": "agenda_item_element_speakers",
      "foreignKey": "agenda_item_element_id",
      "name": "agenda_item_element_speakers",
      "macro": "has_many",
      "resource_name": "AgendaItemElementSpeaker",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "election_id",
      "name": "election",
      "macro": "belongs_to",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_post",
      "macro": "belongs_to",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "file_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Proposal",
      "collectionName": "proposals",
      "foreignKey": "proposal_id",
      "name": "proposal",
      "macro": "belongs_to",
      "resource_name": "Proposal",
      "through": null
    },
    {
      "className": "ProposalType",
      "collectionName": "proposal_types",
      "foreignKey": "proposal_type_id",
      "name": "proposal_type",
      "macro": "belongs_to",
      "resource_name": "ProposalType",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "agenda_item_id",
      "column": {
        "default": null,
        "name": "agenda_item_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_id",
      "column": {
        "default": null,
        "name": "election_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "election_post_id",
      "column": {
        "default": null,
        "name": "election_post_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "element_type",
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "headline",
      "column": {
        "default": null,
        "name": "headline",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "locked",
      "column": {
        "default": false,
        "name": "locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_agenda_item_id",
      "column": {
        "default": null,
        "name": "old_agenda_item_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_election_id",
      "column": {
        "default": null,
        "name": "old_election_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_election_post_id",
      "column": {
        "default": null,
        "name": "old_election_post_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "proposal_id",
      "column": {
        "default": null,
        "name": "proposal_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "proposal_type_id",
      "column": {
        "default": null,
        "name": "proposal_type_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "streaming_enabled",
      "column": {
        "default": true,
        "name": "streaming_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "video_autoplay",
      "column": {
        "default": false,
        "name": "video_autoplay",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "video_url",
      "column": {
        "default": null,
        "name": "video_url",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item",
      "macro": "belongs_to",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "AgendaItemElementSpeaker",
      "collectionName": "agenda_item_element_speakers",
      "foreignKey": "agenda_item_element_id",
      "name": "agenda_item_element_speakers",
      "macro": "has_many",
      "resource_name": "AgendaItemElementSpeaker",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "election_id",
      "name": "election",
      "macro": "belongs_to",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_post",
      "macro": "belongs_to",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    }
  ],
  "paramKey": "agenda_item_element",
  "primaryKey": "id"
}

/** Frontend model for AgendaItemElement. */
export default class AgendaItemElement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  agendaItemId() {
    return this.readAttributeUnderscore("agenda_item_id")
  }

  /** @returns {boolean} */
  hasAgendaItemId() {
    const value = this.agendaItemId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  electionId() {
    return this.readAttributeUnderscore("election_id")
  }

  /** @returns {boolean} */
  hasElectionId() {
    const value = this.electionId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  electionPostId() {
    return this.readAttributeUnderscore("election_post_id")
  }

  /** @returns {boolean} */
  hasElectionPostId() {
    const value = this.electionPostId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementType() {
    return this.readAttributeUnderscore("element_type")
  }

  /** @returns {boolean} */
  hasElementType() {
    const value = this.elementType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  filePath() {
    return this.readAttributeUnderscore("file_path")
  }

  /** @returns {boolean} */
  hasFilePath() {
    const value = this.filePath()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  headline() {
    return this.readAttributeUnderscore("headline")
  }

  /** @returns {boolean} */
  hasHeadline() {
    const value = this.headline()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  locked() {
    return this.readAttributeUnderscore("locked")
  }

  /** @returns {boolean} */
  hasLocked() {
    const value = this.locked()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  proposalId() {
    return this.readAttributeUnderscore("proposal_id")
  }

  /** @returns {boolean} */
  hasProposalId() {
    const value = this.proposalId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  proposalTypeId() {
    return this.readAttributeUnderscore("proposal_type_id")
  }

  /** @returns {boolean} */
  hasProposalTypeId() {
    const value = this.proposalTypeId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  streamingEnabled() {
    return this.readAttributeUnderscore("streaming_enabled")
  }

  /** @returns {boolean} */
  hasStreamingEnabled() {
    const value = this.streamingEnabled()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  videoAutoplay() {
    return this.readAttributeUnderscore("video_autoplay")
  }

  /** @returns {boolean} */
  hasVideoAutoplay() {
    const value = this.videoAutoplay()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  videoUrl() {
    return this.readAttributeUnderscore("video_url")
  }

  /** @returns {boolean} */
  hasVideoUrl() {
    const value = this.videoUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElementType() {
    return this.readAttributeUnderscore("translated_element_type")
  }

  /** @returns {boolean} */
  hasTranslatedElementType() {
    const value = this.translatedElementType()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  lock(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "lock",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  nextSpeaker(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "next_speaker",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  signContactUpAsSpeaker(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sign_contact_up_as_speaker",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  signSelfUpAsSpeaker(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "sign_self_up_as_speaker",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  unlock(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "unlock",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  videoEmbedHtml(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "video_embed_html",
        primaryKey: this.primaryKey(),
        collectionName: "agenda_item_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./agenda-item.js").default | null} */
  agendaItem() {
    return this._readBelongsToReflection({modelClass: AgendaItem, reflectionName: "agenda_item"})
  }

  /** @returns {Promise<import("./agenda-item.js").default | null>} */
  loadAgendaItem() {
    if (!("agendaItemId" in this)) throw new Error("Foreign key method wasn't defined: agendaItemId")

    const id = this.agendaItemId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "agenda_item",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./agenda-item.js").default | null>} */
  ensureAgendaItemLoaded() {
    return this.ensureAssociationLoaded("agenda_item")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item-element-speaker.js").default>} */
  agendaItemElementSpeakers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_item_element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "agenda_item_element_speakers",
        model: this,
        modelClass: AgendaItemElementSpeaker
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element-speaker.js").default>>} */
  loadAgendaItemElementSpeakers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["agenda_item_element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "agenda_item_element_speakers",
        model: this,
        modelClass: AgendaItemElementSpeaker
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element-speaker.js").default>>} */
  ensureAgendaItemElementSpeakersLoaded() {
    return this.ensureAssociationLoaded("agenda_item_element_speakers")
  }

  /** @returns {import("./election.js").default | null} */
  election() {
    return this._readBelongsToReflection({modelClass: Election, reflectionName: "election"})
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  loadElection() {
    if (!("electionId" in this)) throw new Error("Foreign key method wasn't defined: electionId")

    const id = this.electionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "election",
        model: this,
        modelClass: Election
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  ensureElectionLoaded() {
    return this.ensureAssociationLoaded("election")
  }

  /** @returns {import("./election-post.js").default | null} */
  electionPost() {
    return this._readBelongsToReflection({modelClass: ElectionPost, reflectionName: "election_post"})
  }

  /** @returns {Promise<import("./election-post.js").default | null>} */
  loadElectionPost() {
    if (!("electionPostId" in this)) throw new Error("Foreign key method wasn't defined: electionPostId")

    const id = this.electionPostId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "election_post",
        model: this,
        modelClass: ElectionPost
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./election-post.js").default | null>} */
  ensureElectionPostLoaded() {
    return this.ensureAssociationLoaded("election_post")
  }

  /** @returns {import("./active-storage-attachment.js").default | null} */
  fileAttachment() {
    return this._readHasOneReflection({modelClass: ActiveStorageAttachment, reflectionName: "file_attachment"})
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  loadFileAttachment() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["record_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "file_attachment",
        model: this,
        modelClass: ActiveStorageAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  ensureFileAttachmentLoaded() {
    return this.ensureAssociationLoaded("file_attachment")
  }
}
